"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
exports.MissingComponent = function (props) {
    var componentName = props.rendering && props.rendering.componentName
        ? props.rendering.componentName
        : 'Unnamed Component';
    console.log("Component props for unimplemented '" + componentName + "' component", props);
    return (react_1.default.createElement("div", { style: {
            background: 'darkorange',
            outline: '5px solid orange',
            padding: '10px',
            color: 'white',
            maxWidth: '500px',
        } },
        react_1.default.createElement("h2", null, componentName),
        react_1.default.createElement("p", null, "JSS component is missing React implementation. See the developer console for more information.")));
};
exports.MissingComponent.propTypes = {
    rendering: prop_types_1.default.shape({
        componentName: prop_types_1.default.string,
    }),
};
exports.MissingComponent.displayName = 'MissingComponent';
